import type { BoxHTMLProps } from 'reakit';
import { createHook } from 'reakit-system';
import type { BoxOptions } from '../../Box/Box';
import { useBox } from '../../Box/Box';

export const useStepperFieldBox = createHook<BoxOptions, BoxHTMLProps>({
  name: 'StepperFieldBox',
  compose: [useBox],
  useOptions(options) {
    return {
      ...options,
      border: '1',
      borderColor: 'transparent',
      color: 'stepperColor',
      backgroundColor: 'stepperBg',
      styles: {
        textAlign: 'center',
        '::-webkit-inner-spin-button': {
          display: 'none',
          margin: 0,
        },
        'button&:hover': {
          backgroundColor: 'stepperButtonHoverBg',
        },
        'input&:hover': {
          backgroundColor: 'stepperInputHoverBg',
        },
        'input&:focus:hover': {
          backgroundColor: 'transparent',
        },
        '&:active': {
          backgroundColor: 'stepperActiveBg',
        },
        "&[aria-disabled='true']": {
          color: 'stepperDisabledColor',
          backgroundColor: 'stepperDisabledBg',
        },
      },
    };
  },
  useProps(_, props) {
    return {
      ...props,
    };
  },
});
